import React from "react"
import { FaSpinner } from "react-icons/fa"

const Fetching = () => (
    <div className='fetching'>
        <FaSpinner className='spinner' />
    </div>
)

export default Fetching;